import * as React from "react";
import { css } from "emotion";

import { colors, fonts } from "../../shared/config";

// const imagesLoadedOptions = { background: ".my-bg-image-el" };

class Card extends React.Component {
  render() {
    return (
      <div
        className={css`
          height: auto;
          width: 100%;
        `}
      >
        <div
          className={css`
            margin: 5px;
            padding: 30px;
            background-color: ${colors.lightgray};
            font-style: ${fonts.textFont} sans-serif;
          `}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Card;
